import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal, Form, Row, Col, Alert } from "react-bootstrap";
import { addAddress } from "state/adminData/actions";
import swal from "sweetalert";
import AddressAutocompleteInput from "./AddressAutocompleteInput";

const AddAddressComponent = ({ title }) => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [addressInfo, setAddressInfo] = useState({
    name_address: "",
    street_number: "",
    street: "",
    address_complement: "",
    postal_code: "",
    city: "",
    delivery_information: "",
    recover_information: "",
    parking_information: "",
    useful_number: "",
    note: ""
  });

  const handleClose = () => {
    setShow(false);
    setError(""); // Réinitialiser les erreurs à la fermeture
    setAddressInfo({
      name_address: "",
      street_number: "",
      street: "",
      address_complement: "",
      postal_code: "",
      city: "",
      delivery_information: "",
      recover_information: "",
      parking_information: "",
      useful_number: "",
      note: ""
    });
  };
  const handleShow = () => setShow(true);

  const handleChange = (e) => {
    setAddressInfo({
      ...addressInfo,
      [e.target.name]: e.target.value,
    });
  };

  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    setError(""); // Réinitialiser les erreurs
    try {
      setIsLoading(true);
      const resp = await dispatch(addAddress(addressInfo));
      
      if (resp?.result?.success === false || resp?.success === false) {
        const errorMsg = resp?.result?.message || resp?.message || "Une erreur est survenue";
        setError(errorMsg);
      } else {
        swal({
          title: "Adresse ajoutée au carnet",
          text: "L'adresse a été ajoutée avec succès, vous pouvez l'utiliser dès maintenant dans vos adresses de devis.",
          icon: "success",
          dangerMode: false,
        });
      }
    } catch (err) {
      setIsLoading(false);
      setError(err?.message || "Une erreur est survenue");
    }
  };

  return (
    <>
      <Button variant="success" size="sm" block onClick={handleShow}>
        {title}
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && (
            <Alert variant="danger" className="mb-3">
              {error}
            </Alert>
          )}
          <Form onSubmit={handleSubmit}>
              <Form.Group>
                <Form.Label>Nom de l'adresse*</Form.Label>
                  <Form.Control
                    type="text"
                    name="name_address"
                    value={addressInfo.name_address}
                    onChange={handleChange}
                    required
                    disabled={isLoading}
                  />
              </Form.Group>
              <Form.Group>
                <Form.Label>Recherche d'adresse (remplit les champs ci-dessous)</Form.Label>
                <AddressAutocompleteInput
                  disabled={isLoading}
                  onSelect={(address) =>
                    setAddressInfo({
                      ...addressInfo,
                      street_number: address.streetNumber,
                      street: address.street,
                      postal_code: address.postalCode,
                      city: address.city,
                    })
                  }
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Numéro de rue*</Form.Label>
                                  <Form.Control
                    type="text"
                    name="street_number"
                    value={addressInfo.street_number}
                    onChange={handleChange}
                    required
                    disabled={isLoading}
                  />
              </Form.Group>
              <Form.Group>
                <Form.Label>Rue*</Form.Label>
                                  <Form.Control
                    type="text"
                    name="street"
                    value={addressInfo.street}
                    onChange={handleChange}
                    required
                    disabled={isLoading}
                  />
              </Form.Group>
              <Form.Group>
                <Form.Label>Complément d'adresse</Form.Label>
                                  <Form.Control
                    type="text"
                    name="address_complement"
                    value={addressInfo.address_complement}
                    onChange={handleChange}
                    disabled={isLoading}
                  />
              </Form.Group>
              <Form.Group>
                <Form.Label>Code postal*</Form.Label>
                                  <Form.Control
                    type="text"
                    name="postal_code"
                    value={addressInfo.postal_code}
                    onChange={handleChange}
                    minLength="5"
                    maxLength="5"
                    required
                    disabled={isLoading}
                  />
              </Form.Group>
              <Form.Group>
                <Form.Label>Ville*</Form.Label>
                                  <Form.Control
                    type="text"
                    name="city"
                    value={addressInfo.city}
                    onChange={handleChange}
                    required
                    disabled={isLoading}
                  />
              </Form.Group>
              <Form.Group>
                <Form.Label>Commentaire interne sur la livraison</Form.Label>
                                  <Form.Control
                    as="textarea"
                    name="delivery_information"
                    value={addressInfo.delivery_information}
                    onChange={handleChange}
                    disabled={isLoading}
                  />
              </Form.Group>
              <Form.Group>
                <Form.Label>Commentaire interne sur la récupération</Form.Label>
                                  <Form.Control
                    as="textarea"
                    name="recover_information"
                    value={addressInfo.recover_information}
                    onChange={handleChange}
                    disabled={isLoading}
                  />
              </Form.Group>
              <Form.Group>
                <Form.Label>Informations sur le parking</Form.Label>
                                  <Form.Control
                    as="textarea"
                    name="parking_information"
                    value={addressInfo.parking_information}
                    onChange={handleChange}
                    disabled={isLoading}
                  />
              </Form.Group>
              <Form.Group>
                <Form.Label>Numéro utile</Form.Label>
                                  <Form.Control
                    type="text"
                    name="useful_number"
                    value={addressInfo.useful_number}
                    onChange={handleChange}
                    disabled={isLoading}
                  />
              </Form.Group>
              <Form.Group>
                <Form.Label>Notation de l'adresse (accessibilité, etc...)</Form.Label>
                                  <Form.Control
                    as="select"
                    name="note"
                    value={addressInfo.note}
                    onChange={handleChange}
                    disabled={isLoading}
                  >
                    <option value="">Attribuer une note</option>
                    <option value="1">1 sur 5</option>
                    <option value="2">2 sur 5</option>
                    <option value="3">3 sur 5</option>
                    <option value="4">4 sur 5</option>
                    <option value="5">5 sur 5</option>
                  </Form.Control>
              </Form.Group>
              <Button variant="success" type="submit" block disabled={isLoading}>
                {isLoading ? (
                  <>
                    <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                    Enregistrement en cours...
                  </>
                ) : (
                  "Enregistrer"
                )}
              </Button>
            </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddAddressComponent; 